import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import GenericButton from "../Custom/GenericButton";
import { useTranslation } from "react-i18next";

const SoilTestLabCard = ({ lab }) => {
  const { t } = useTranslation();

  const onDirectionsClick = (latitude, longitude) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
    );
  };

  const onContactClick = (contact) => {
    window.open(`tel:${contact}`);
  };

  return (
    <Card
      sx={{
        boxShadow: "none",
        border: "2px solid #A5A5A5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%", // Ensures uniform height
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6">{lab.name}</Typography>
        <Typography variant="body2">
          {t("District")}: {lab.district}
        </Typography>
        {lab.distance && (
          <Typography variant="body2">
            {t("Distance")}: {lab.distance} {t("km")}
          </Typography>
        )}
        <Typography variant="body2">{lab.address}</Typography>
      </CardContent>

      {/* Wrapper to ensure button stays at the bottom */}
      <Box
        sx={{ padding: "16px", textAlign: "center", display: "flex", gap: 1 }}
      >
        <GenericButton
          backgroundColor="primary"
          fontColor={"#fff"}
          fontSize={"14px"}
          padding={"7px 10px"}
          onClick={() => {
            onDirectionsClick(lab.latitude, lab.longitude);
          }}
        >
          {t("Directions")}
        </GenericButton>
        <GenericButton
          backgroundColor="primary"
          fontColor={"#fff"}
          fontSize={"14px"}
          padding={"7px 10px"}
          onClick={() => {
            onContactClick(lab.contact);
          }}
        >
          {t("Contact")}
        </GenericButton>
      </Box>
    </Card>
  );
};

export default SoilTestLabCard;
